import { NgModule } from '@angular/core';
import { PageMetaResolver, ProductPageMetaResolver } from '@spartacus/core';
import { CustomSearchPageMetaResolver } from './product-search-page-meta.resolver';
import { CustomContentPageMetaResolver } from './content-page-meta.resolver';
import { CustomProductPageMetaResolver } from './product-page-meta.resolver';
import { CustomLoginPageMetaResolver } from './login-page-meta.resolver';

@NgModule({
  declarations: [],
  providers: [
    {
      provide: PageMetaResolver,
      useClass: CustomSearchPageMetaResolver,
      multi: true,
    },
    {
      provide: PageMetaResolver,
      useClass: CustomContentPageMetaResolver,
      multi: true,
    },
    {
      provide: ProductPageMetaResolver,
      useClass: CustomProductPageMetaResolver,
    },
    {
      provide: PageMetaResolver,
      useClass: CustomLoginPageMetaResolver,
      multi: true,
    },
  ],
})
export class CustomResolversModule {}
